// Hồ sơ đã trình ký thì danh sách file đã được chụp lại cho các bước duyệt/ký nên không được đổi file nữa.
export const DOCUMENT_FILES_LOCKED_MESSAGE =
  "Hồ sơ đã trình ký nên không thể thay đổi file. Nếu cần đổi file, hãy tạo hồ sơ mới và trình ký lại.";

export const DOCUMENT_FILES_LOCKED_REASON =
  "Khi trình ký, hệ thống lưu lại đúng các file này cho người duyệt/ký. Nếu đổi file sau đó, người duyệt sẽ vẫn thấy file cũ nên không thể sửa.";
